<script setup lang="ts">
import type { Legend } from "@/types/legend.types";
import CanvasSettingsState from "@/stores/CanvasSettingsState";
import { Logger } from "@/logger";
import LegendViewerState from "@/stores/LegendViewerState";
import SettingsSelectItem from "./SettingsSelectItem.vue";
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";
import { trackTab } from "@/analytics/drawing-analytics";

const legends = CanvasSettingsState.legends;

function activateLegend(legend: Legend) {
  Logger.info(`Legend.vue : activating legend ${legend.name}`);
  trackTab("settings", "legend_changed", {
    legendId: legend.id,
    legendName: legend.name,
  });
  CanvasSettingsState.onLegendChange(legend);
  Logger.info(`Legend.vue : legend ${legend.name} activated`);
}

function openConfigurator(legend: Legend) {
  LegendViewerState.show(legend, "readonly");
}
</script>

<template>
  <div class="btn-group dropdown">
    <SettingsSelectItem
      :title="$t('canvas:settings.key.legend')"
      :label="CanvasSettingsState.activeLegend?.name"
    />

    <ul class="dropdown-menu dropdown-menu-dark w-100">
      <li
        class="d-flex align-items-center px-2"
        v-for="legend in legends"
        :key="legend.id"
      >
        <a
          @click="activateLegend(legend)"
          class="dropdown-item d-flex justify-content-between"
          :class="{
            active: CanvasSettingsState.activeLegend?.name === legend.name,
          }"
        >
          {{ legend.name }}
        </a>
        <PhosphorIcon
          name="arrow-square-out"
          :size="20"
          @click.stop="openConfigurator(legend)"
        />
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.legend-open-icon {
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  flex-shrink: 0;
  &:hover {
    color: white;
  }
}
</style>
